import { useMyEcosystemHeadLinksQuery } from "@/state/hooks/useMyEcosystemHeadLinksQuery";

/**
 * Sidebar badge count — reads the same cached list as My Cluster / Explore.
 * Invalidation goes through notifyMyClusterCountChanged → invalidateMyEcosystemHeadLinks.
 */
export function useMyEcosystemHeadCount(enabled = true) {
  const query = useMyEcosystemHeadLinksQuery(enabled);

  return {
    count: query.data?.links.length ?? 0,
    loading: query.isInitialLoading,
    refresh: () => query.refetch(),
  };
}
